module.exports = __webpack_public_path__ + "static/media/IMG_0005.e6e642aa.jpg";